module.exports = __webpack_public_path__ + "d4f5c952.svg";